import FolderOutlined from "@mui/icons-material/FolderOutlined";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  type CardProps,
  Chip,
  Stack,
  Typography,
} from "@mui/material";
import { type FC } from "react";
import type { Folder } from "./server/folder-service";
import { useSearchParams } from "react-router";

export const FolderCard: FC<
  {
    folder: Folder;
  } & CardProps
> = ({ folder, ...props }) => {
  const [, setSearchParams] = useSearchParams();

  return (
    <Card variant="outlined" {...props} onClick={() => setSearchParams({ folder: folder.id })}>
      <CardActionArea>
        <Box
          role="img"
          sx={{
            height: "200px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <FolderOutlined sx={{ width: "128px", height: "128px", color: "primary.main" }} />
        </Box>

        <CardContent>
          <Stack spacing={2}>
            <Typography variant="subtitle1" noWrap textOverflow="ellipsis">
              {folder.name}
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Chip label="Folder" />
            </Stack>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
